module.exports = __webpack_public_path__ + "img/rating.34537c86.svg";